export class LSFooterLocalizations extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return;
    this.abortController = new AbortController();
    this.addEventListener('change', (event) => this.onChange(event), {
      signal: this.abortController.signal,
    });
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = null;
  }

  onChange(event) {
    const select = event.target.closest?.('[data-ls-footer-localization]');
    if (!select || !this.contains(select)) return;
    select.form?.requestSubmit();
  }
}

if (!customElements.get('ls-footer-localizations')) {
  customElements.define('ls-footer-localizations', LSFooterLocalizations);
}
